<template>
  <b-container class="background_qrcode m-0 p-0" fluid>
    <template v-if="isLoginCheck">
      <!-- ログインチェック -->
      <template v-if="userStreamer !== undefined">
        <b-row class="text-left" align-v="center"> 
          <b-col class="m-3" cols="1">
            <b-img center :src="userStreamer.iconUrl" rounded="circle" alt="Circle image" width="32px"></b-img>
          </b-col>
          <b-col cols="auto">
            <b-row>
              <b-col class="text_nickname my-0 py-0">{{ userStreamer.nickname }}</b-col>
            </b-row>
            <b-row>
              <b-col class="text_vlive_id my-0 py-0">ID {{ userStreamer.vliveId }}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-row align-v="center" class="h-100 text-center">
          <b-col>
            <b-row>
              <b-img center src="/img/qrcode/qrcodeLoginError.png" alt="loginError"/>
            </b-row>
            <b-row>
              <!-- ログインできませんでした -->
              <b-col class="text_strong mt-5 mx-3">{{ $t('qrcodeLoginErrorText1') }}</b-col>
            </b-row>
            <b-row>
              <!-- ログインを行ってから再度QRコードを読み取ってください。 -->
              <b-col class="text_description mt-4 mx-3">{{ $t('qrcodeLoginErrorText2') }}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </template>

      <!-- プレゼントのチェック -->
      <template v-if="isPresentCheck">
        <template v-if="present != undefined && !isPresentReceivedCheckError">
          <b-row align-v="center" class="text-center h-75">
            <b-col>
              <b-row>
                <b-col>
                  <div v-if="getPresent.presentType != 4" style="position:relative;min-height:294px">
                    <b-img v-if="!isReceived && isPresentReceiveCheck" class="img_item" center src="/img/qrcode/qrcodeItemBack.png" alt="ItemBack"/>
                    <b-img v-if="getPresent.presentType == 1" class="img_item" center src="/img/qrcode/qrcodeCoin.png" alt="Coin"/>
                    <b-img v-if="getPresent.presentType == 6" class="img_item" center src="/img/qrcode/qrcodeGachaTicket.png" alt="GachaTicket"/>
                    <b-img v-if="!isReceived && isPresentReceiveCheck" class="img_item" center src="/img/qrcode/qrcodeItemFront.png" alt="ItemFront"/>
                  </div>
                  <div v-if="getPresent.presentType == 4" style="position:relative;min-height:294px">
                    <div v-for="item, i in getPresent.presentItem.avatarItems" :key="i" style="position:relative;height:294px" >
                      <b-img v-if="!isReceived && isPresentReceiveCheck" class="img_item" center src="/img/qrcode/qrcodeItemBack.png" alt="ItemBack"/>
                      <b-img center class="img_item" :src="item.colorThumbnailUrl" alt="AvatarItem"/>
                      <b-img v-if="!isReceived && isPresentReceiveCheck" class="img_item" center src="/img/qrcode/qrcodeItemFront.png" alt="ItemFront"/>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="!isReceived && isPresentReceiveCheck">
                <!-- 特典を受け取りました -->
                <b-col class="text_strong mt-3">
                  {{ $t('qrcodeItemReceiveText1') }}
                </b-col>
              </b-row>
              <b-row v-else-if="!isReceived">
                <!-- 特典を受け取りますか？ -->
                <b-col class="text_strong mt-3">
                  {{ $t('qrcodeItemReceiveText2') }}
                </b-col>
              </b-row>
              <b-row v-if="isReceived">
                <!-- すでに受け取り済みです -->
                <b-col class="text_strong mt-3">
                  {{ $t('qrcodeItemReceiveText3') }}
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <!-- コイン ○C -->
                <b-col v-if="getPresent.presentType == 1" class="text_description">
                  {{ $t('qrcodeCoinText', { coin:getPresent.presentAmount }) }}
                </b-col>
                <!-- ガチャチケット ○枚 -->
                <b-col v-if="getPresent.presentType == 6" class="text_description">
                  {{ $t('qrcodeGachaTicketText', { gachaTicket:getPresent.presentAmount }) }}
                </b-col>
                <b-col v-if="getPresent.presentType == 4">
                  <div  v-for="item, i in getPresent.presentItem.avatarItems" :key="i" class="text_description">
                    {{ item.name }}
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="!isReceived && !isPresentReceiveCheck" class="text_receive_at mt-5">
                <!-- 受取期限 --> <!-- 受取期限なし -->
                <b-col>
                  {{ $t('qrcodeDeadlineText') }}: {{ getPresent.endAt ? formatTime(getPresent.endAt) + " (JST)" : $t('qrcodeNoDeadlineText') }}
                </b-col>
              </b-row>
              <b-row v-if="!isReceived && !isPresentReceiveCheck" class="mt-3 pb-3">
                <b-col>
                  <!-- 受け取る -->
                  <ButtonSubmit
                    id="personal__submit_button"
                    :title="$t('qrcodeReceiveText')"
                    v-bind:disabled="isPresentReceiving"
                    v-on:click.native="submit"
                    />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="present == undefined">
          <b-row align-v="center" class="h-75 text-center">
            <b-col>
              <b-row>
                <b-img center src="/img/qrcode/qrcodeError.png" alt="qrcodeError"/>
              </b-row>
              <b-row class="mt-5 mx-3">
                <!-- QRコードが確認できませんでした -->
                <b-col class="text_strong">{{ $t('qrcodeErrorText1') }}</b-col>
              </b-row>
              <b-row class="mt-4 mx-3">
                <!-- コードが無効または有効期限外の可能性があります。 -->
                <b-col class="text_description">
                  {{ $t('qrcodeErrorText2') }}
                </b-col>
              </b-row>
              <b-row class="mx-3">
                <!-- ご不明な点がございましたらお問い合わせよりご連絡をお願いいたします。-->
                <b-col class="text_description">
                  {{ $t('qrcodeErrorText3') }}<a :href="`../../inquiry.html`">{{ $t('qrcodeErrorText4') }}</a>{{ $t('qrcodeErrorText5') }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="isPresentReceivedCheckError">
          <b-row align-v="center" class="h-75 text-center">
            <b-col>
              <b-row>
                <b-img center src="/img/qrcode/qrcodeError.png" alt="qrcodeError"/>
              </b-row>
              <b-row class="mt-5 mx-3">
                <!-- QRコードが確認できませんでした -->
                <b-col class="text_strong">{{ $t('qrcodeErrorText1') }}</b-col>
              </b-row>
              <b-row class="mt-4 mx-3">
                <!-- コードが無効または有効期限外の可能性があります。 -->
                <b-col class="text_description">
                  {{ $t('qrcodeErrorText2') }}
                </b-col>
              </b-row>
              <b-row class="mx-3">
                <!-- ご不明な点がございましたらお問い合わせよりご連絡をお願いいたします。-->
                <b-col class="text_description">
                  {{ $t('qrcodeErrorText3') }}<a :href="`../../inquiry.html`">{{ $t('qrcodeErrorText4') }}</a>{{ $t('qrcodeErrorText5') }}
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </template>
      </template>
    </template>
  </b-container>
</template>

<script> // import APIRequest from '@/utils/APIRequest'
import API from '@/utils/API'
import { LanguageQueryMixin } from '@/mixins/LanguageQuery'
import ButtonSubmit from '@/components/ButtonSubmit'
import { formatTime } from '@/utils/time'
import { getUserStreamer } from '@/utils/UserStreamer'
import * as QueryString from 'query-string'

export default {
  components: {
    ButtonSubmit
  },
  mixins: [LanguageQueryMixin],
  name: 'QrcodePage',
  props: {
    code: String,
  },
  data: function () {
    return {
      isLoginCheck: false,
      isPresentCheck: false,
      isPresentReceiving: false,
      isPresentReceiveCheck: false,
      isPresentReceivedCheckError: false,
      userStreamer: undefined,
      present: undefined,
      received: false,
    }
  },
  computed: {
    getNickName: function() {
      return this.userStreamer?.nickname ?? ''
    },
    getPresent: function() {
      return this.present
    },
    isReceived: function() {
      return this.received
    }
  },
  watch: {

  },
  methods: {
    initialize: async function() {
      await this.setUserStreamer()
      await this.setPresentFromQrcode()
    },
    setUserStreamer: async function () {
      try {
        this.userStreamer = await getUserStreamer()
      } catch (error) {
        this.userStreamer = undefined
      } finally {
        this.isLoginCheck = true
      }
    },
    setPresentFromQrcode: async function() {
      if (this.userStreamer === undefined) {
        return
      }

      try {
        const request = API.Request.presentGetFromCode(this.code)
        const response = await API.load(request)
        this.present = response.present
        this.received = response.received
      } catch (error) {
        this.present = undefined
      } finally {
        this.isPresentCheck = true
      }
    },
    submit: async function() {
      try {
        this.isPresentReceiving = true
        if (this.userStreamer !== undefined) {
          const request = API.Request.presentReceiveCode(this.code)
          const response = await API.load(request)
          this.received = response.received
        }
      } catch (error) {
        this.isPresentReceivedCheckError = true
      } finally {
        this.isPresentReceiveCheck = true
        this.isPresentReceiving = false
      }
    },
    formatTime: function(dt) {
      return formatTime(dt, 'YYYY/MM/DD HH:mm')
    },
    isClientViewer: function () {
      const params = QueryString.parse(window.location.search)
      const tp = params.tp
      const vliveClient = params.vlive_client
      if (tp !== undefined || vliveClient !== undefined) return true
      return false
    }
  },
  created() {
    if (this.isClientViewer()) {
      this.initialize()
    } else {
      this.$router.push('/download').catch(() => {})
    }
  },
}
</script>

<style scoped>
.background_qrcode {
  position: fixed;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  background-image: url("/img/qrcode/qrcodeBackground.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: scroll;
  overflow-x: hidden;
}

.text_description {
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 22px;
  color: #262626;
}

.text_strong {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  color: #262626;
}

.text_nickname {
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: #262626;
}

.text_vlive_id {
  font-family: 'Hiragino Kaku Gothic ProN';
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 15px;
  color: #808080;
}

.text_receive_at {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 17px;
  color: #808080;
}

.img_item{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

#personal__submit_button {
  width: 224px;
  height: 44px;
  display: table;
  margin: auto;
}
</style>
